import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { getAllBatches, deleteBatch } from "../server/rolesAllApi";
import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios"; // Make sure axios is imported
import Breadcrumb from "../Breadcrumb";
// for deletion
import { Modal } from "react-bootstrap";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const BatchesListLayer = () => {
  const [batches, setBatches] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [serialNumbers, setSerialNumbers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [token, setToken] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedBatchStatus, setSelectedBatchStatus] = useState(""); // To store the selected batch status
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBatchId, setSelectedBatchId] = useState(""); // To store the selected batch_id
  const [startDate, setStartDate] = useState(""); // Start date for filtering
  const [endDate, setEndDate] = useState(""); // End date for filtering
  // for deletion
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [roleName, setRoleName] = useState("");
  const [userName, setUserName] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage?.getItem("token");
    const user = localStorage?.getItem("user");
    const parsedUser = JSON.parse(user);
    const role = parsedUser?.rolename;
    const userEmail = parsedUser?.userName;
    setUserName(userEmail);
    setRoleName(role);
    // console.log(role);

    setToken(storedToken);
  }, []);

  const roleId = localStorage.getItem("roleId"); // Replace with actual role fetching logic
  const isTutor = roleName === "Tutor"; // Assuming this is the tutor's role ID

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
  }, []);

  useEffect(() => {
    if (token) {
      fetchBatches();
    }
  }, [
    token,
    currentPage,
    itemsPerPage,
    searchTerm,
    startDate,
    endDate,
    selectedBatchStatus,
  ]); // Added startDate and endDate to trigger re-fetch

  // useEffect(() => {
  //   if (token) {
  //     fetchBatchByBatchStatus();
  //   }
  // }, [selectedBatchStatus]);

  const fetchBatches = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      // Construct the API URL with query parameters including selectedBatchId, startDate, and endDate
      // const url = !selectedBatchStatus && selectedBatchStatus=="Select All"?`${process.env.REACT_APP_INSTITUTION_BASEURL}/getbatches-by-status/${selectedBatchStatus}?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}&start_date=${startDate}&end_date=${endDate}` : `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-batch?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}&start_date=${startDate}&end_date=${endDate}`;
      const url =
        !selectedBatchStatus || selectedBatchStatus == "Select All"
          ? `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-batch?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}&start_date=${startDate}&end_date=${endDate}`
          : `${process.env.REACT_APP_INSTITUTION_BASEURL}/getbatches-by-status/${selectedBatchStatus}?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}&start_date=${startDate}&end_date=${endDate}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // setBatches(response.data.data.data); // Update to your API structure
      // setTotalItems(response.data.data.pagination.totalItems); // Assuming your API returns this
      // console.log("Response received:", response);
      const startSerial = (currentPage - 1) * itemsPerPage + 1; // Start serial for the current page
      const usersWithSerial = response.data.data.map((item, index) => ({
        ...item,
        serial: startSerial + index, // Calculate serial number correctly
        statusToggle: !item.status,
      }));
      setBatches(usersWithSerial);
      setSerialNumbers(usersWithSerial.map((t) => t.serial));
      setTotalItems(response.data.pagination.totalItems); // Set totalItems for pagination
      setTotalPages(response.data.pagination.totalPages);
      // console.log("totalItems, totalPages: ", totalItems, totalPages);
    } catch (error) {
      console.error("Failed to fetch batches:", error);
      setError("Failed to fetch batches.");
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditBatch = (batch) => {
    navigate("/editbatch", { state: { batch } });
  };

  const handleViewStudent = (batch) => {
    navigate("/student-list", { state: { batch } });
  };

  // for Deletion
  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleConfirmDelete = async () => {
    try {
      // Your delete logic here
      await handleDeleteBatch(itemToDelete);
      handleCloseDeleteModal();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const handleDeleteBatch = async (batch) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/delete-batch/${batch._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Deleted successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        handleCloseDeleteModal();
        fetchBatches();
      }
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleToggleStatus = async (batch) => {
    try {
      const updatedStatus = !batch.status; // Toggle the current status
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/batch-status-update/${batch._id}`,
        { status: updatedStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // Update the status locally
        setBatches((prevBatches) =>
          prevBatches.map((b) =>
            b._id === batch._id ? { ...b, status: updatedStatus } : b
          )
        );
        setSnackbarMessage("Status updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to toggle batch status:", error);
      setSnackbarMessage("Failed to update status. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <h5>Batches </h5>
        <Breadcrumb title="Batches" />
      </div>
      <div className="card h-100 p-0 radius-12">
        {loading && (
          <div className="loader-container" style={styles.loaderContainer}>
            <CircularProgress />
          </div>
        )}
        <div className="card-header border-bottom bg-base py-16 px-24">
          <div className="row g-3">
            {/* Search field */}
            <div className="col-12 col-sm-6 col-md-6 col-xl-3">
              <form
                className="search px-10"
                style={{
                  border: "1px solid #6b7280",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "10px",
                }}
                onSubmit={(e) => e.preventDefault()}
              >
                <Icon
                  icon="ion:search-outline"
                  className="icon"
                  style={{ marginRight: "10px" }}
                />
                <input
                  type="text"
                  className="bg-base h-40-px"
                  name="search"
                  onChange={(e) => {
                    let value = e.target.value;

                    // Remove leading/trailing spaces & allow only alphanumeric and spaces
                    value = value.replace(/[^a-zA-Z0-9\s]/g, "").trimStart();

                    setSearchTerm(value);
                    setCurrentPage(1); // Reset to the first page
                  }}
                  value={searchTerm}
                  placeholder="Search"
                />
              </form>
            </div>

            {/* Batch Status dropdown */}
            {roleName === "Admin" && (
              <div className="col-12 col-sm-6 col-md-6 col-xl-3">
                <select
                  id="batchStatus"
                  name="batchStatus"
                  value={selectedBatchStatus}
                  onChange={(e) => setSelectedBatchStatus(e.target.value)}
                  className="form-select"
                  required
                >
                  <option value="" disabled>
                    Select Batch status
                  </option>
                  <option value="Select All">Select All</option>
                  <option value="previous">Previous</option>
                  <option value="ongoing">Ongoing</option>
                  <option value="upcoming">Upcoming</option>
                </select>
              </div>
            )}

            {/* Date fields */}
            <div className="col-12 col-sm-6 col-md-6 col-xl-2">
              <input
                type="date"
                id="startDate"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="form-control"
              />
            </div>

            <div className="col-12 col-sm-6 col-md-6 col-xl-2">
              {/* {startDate &&   */}
              <input
                type="date"
                id="endDate"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="form-control"
              />
              {/* } */}
            </div>
            <div
              className="col-12 col-sm-6 col-md-6 col-xl-2"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                order: "2",
                marginLeft: "auto",
              }}
            >
              {roleName === "Admin" && (
                <Link
                  to="/add-batch"
                  className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center  gap-2"
                >
                  <Icon icon="ic:baseline-plus" />
                  Add New
                </Link>
              )}
            </div>
          </div>
        </div>
        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="d-flex align-items-center gap-10">
                      <div className="form-check style-check d-flex align-items-center"></div>
                      S.L
                    </div>
                  </th>
                  <th scope="col">Batch Name</th>
                  <th scope="col">Tutor</th>
                  <th scope="col">Course Name</th>
                  <th scope="col">Batch Status</th>
                  <th scope="col">Batch ID</th>
                  <th scope="col">NO. of Students</th>
                  <th scope="col">Start Date</th>
                  <th scope="col">End Date</th>
                  <th scope="col">Created At</th>
                  {roleName === "Admin" && (<th scope="col">Status</th>)}
                  <th scope="col" className="text-center">
                    {isTutor ? "View Students" : "Action"}{" "}
                    {/* Conditional header based on role */}
                  </th>
                </tr>
              </thead>
              <tbody>
                {batches.length > 0 ? (
                  batches.map((batch, index) => (
                    <tr key={batch._id}>
                      <td>
                        <div className="d-flex align-items-center gap-10">
                          <div className="form-check style-check d-flex align-items-center">
                            {/* <input
                            className="form-check-input radius-4 border border-neutral-400"
                            type="checkbox"
                            name="checkbox" /> */}
                          </div>
                          {batch.serial}
                        </div>
                      </td>
                      <td>{batch?.batch_name}</td>
                      <td>{batch?.tutorData?.name}</td>
                      <td style={{ width: "369px", wordWrap: "break-word", whiteSpace: "normal" }}>{batch?.courseData?.coursename}</td>
                      <td>{batch?.batch_status}</td>
                      <td>{batch?.batch_id}</td>
                      <td>{batch?.studentCount}</td>
                      <td>
                        {new Date(
                          batch?.batch_start_duration
                        ).toLocaleDateString("en-GB")}
                      </td>
                      <td>
                        {new Date(
                          batch?.batch_end_duration
                        ).toLocaleDateString("en-GB")}
                        
                      </td>
                      <td>
                      {new Date(
                          batch?.createdAt
                        ).toLocaleDateString("en-GB")}{" "}
                        {new Date(
                          batch?.createdAt
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </td>
                      {roleName === "Admin" && (
                      <td>
                        <button
                          onClick={() => handleToggleStatus(batch)}
                          className={`bg-${
                            batch.status ? "success" : "danger"
                          }-focus text-${
                            batch.status ? "success" : "danger"
                          }-600 border border-${
                            batch.status ? "success" : "danger"
                          }-main px-24 py-4 radius-4 fw-medium text-sm`}
                          style={{ cursor: "pointer" }}
                        >
                          {batch.status ? "Active" : "Inactive"}
                        </button>
                      </td>
                      )}
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          {roleName == "Tutor" && (
                            <button
                              type="button"
                              className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              onClick={() => handleViewStudent(batch)}
                            >
                              <Icon
                                icon="majesticons:eye-line"
                                className="icon text-xl"
                              />
                            </button>
                          )}
                          {roleName == "Admin" && (
                            <button
                              type="button"
                              className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              onClick={() => handleEditBatch(batch)}
                            >
                              <Icon icon="lucide:edit" className="menu-icon" />
                            </button>
                          )}
                          {roleName == "Admin" && (
                            <button
                              type="button"
                              className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                              onClick={() => handleDeleteClick(batch)}
                            >
                              <Icon
                                icon="fluent:delete-24-regular"
                                className="menu-icon"
                              />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No batches found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
            <span>
              Showing{" "}
              {batches.length === 0
                ? "0"
                : `${(currentPage - 1) * itemsPerPage + 1}`}{" "}
              to {Math.min(currentPage * itemsPerPage, totalItems)} of{" "}
              {totalItems} entries
            </span>

            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
              {/* Previous Button */}
              <li className="page-item">
                <Link
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                  to="#"
                  onClick={() => handlePageChange(currentPage - 1)}
                  style={{
                    pointerEvents: currentPage === 1 ? "none" : "auto",
                    opacity: currentPage === 1 ? 0.5 : 1,
                  }}
                >
                  <Icon icon="ep:d-arrow-left" />
                </Link>
              </li>

              {/* Current Page Number */}
              <li className="page-item">
                <span className="page-link bg-primary-600 text-white fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md">
                  {currentPage}
                </span>
              </li>

              {/* Next Button */}
              <li className="page-item">
                <Link
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                  to="#"
                  onClick={() => handlePageChange(currentPage + 1)}
                  style={{
                    pointerEvents: currentPage === totalPages ? "none" : "auto",
                    opacity: currentPage === totalPages ? 0.5 : 1,
                  }}
                >
                  <Icon icon="ep:d-arrow-right" />
                </Link>
              </li>
            </ul>
          </div>

          {/* for deletion */}
          <Modal
            show={showDeleteModal}
            onHide={handleCloseDeleteModal}
            centered
            backdrop="static"
            size="sm"
          >
            <div className="modal-content radius-16 bg-base">
              <div className="modal-body p-24 text-center">
                <span className="mb-16 fs-1 line-height-1 text-danger d-block">
                  <Icon icon="fluent:delete-24-regular" className="menu-icon" />
                </span>
                <h6 className="text-lg fw-semibold text-primary-light mb-0">
                  Are you sure you want to delete this batch?
                </h6>
                <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                  <button
                    type="button"
                    onClick={handleCloseDeleteModal}
                    className="w-50 border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={handleConfirmDelete}
                    className="w-50 btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          <Snackbar
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert
              onClose={handleCloseSnackbar}
              severity={snackbarSeverity}
              sx={{ width: "100%" }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
      </div>
    </>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default BatchesListLayer;
